
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosResponse } from "axios";
import { Overlay } from "@/lib/Overlay";
import moment from "moment";
import { Snackbar } from "@/lib/Snackbar";
import Swal from "sweetalert2";
export default Vue.extend({
  name: "TwoAuthenticator",

  data() {
    return {
      code: "",
      pinCode: "",
      isMobile: false,
      dialogSetup2FA: false,
      dialogRemove2FA: false,
      lang: navigator.language,
      twoFactorStatus: false,
      twoFactorSecret: "",
      twoFactorQR: "",
      errors: [],
      moment: moment,
    };
  },
  created() {
    this.isMobile = this.detectMobile();
    this.get2FAStatus();
  },
  methods: {
    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    get2FAStatus() {
      Overlay.show();

      Api.get("/v2/client/profile/security/2fa/status")
        .then((response) => {
          this.twoFactorStatus = response.data.body.totp;
        })

        .finally(() => {
          Overlay.hide();
        });
    },

    getQRCode2FA() {
      Overlay.show();

      Api.get("/v2/client/profile/security/2fa/getQRCode")
        .then((response) => {
          this.twoFactorQR = response.data.body.qrCode;
          this.twoFactorSecret = response.data.body.secret;

          this.dialogSetup2FA = true;
        })

        .finally(() => {
          Overlay.hide();
        });
    },

    ativar2FA() {
      if (this.code.length != 6) {
        Snackbar.show(
          "Insira os 6 dígitos do aplicativo de autenticação.",
          "error"
        );
        return false;
      }
      if (this.pinCode.length != 6) {
        Snackbar.show("Informe o PIN de transações.", "error");
        return false;
      }
      this.dialogSetup2FA = false;
      Overlay.show();

      Api.post("/v2/client/profile/security/2fa/register", {
        transactionPin: this.pinCode,
        code: this.code,
        secret: this.twoFactorSecret,
      })
        .then((response) => {
          this.code = "";
          this.pinCode = "";
          Swal.fire({
            title: response.data.body.message,
            icon: "success",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
          this.get2FAStatus();
          this.pinCode = "";
          this.code = "";
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          this.dialogSetup2FA = true;
          Swal.fire({
            text: data.body.error,
            icon: "error",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
          this.pinCode = "";
        })
        .finally(() => {
          Overlay.hide();
        });
    },

    remove2FA() {
      this.dialogRemove2FA = false;
      Overlay.show();

      Api.post("/v2/client/profile/security/2fa/unregister", {
        transactionPin: this.pinCode,
      })
        .then((response) => {
          this.code = "";
          this.pinCode = "";
          Swal.fire({
            title: response.data.body.message,
            icon: "success",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
          this.get2FAStatus();
          this.pinCode = "";
          this.code = "";
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          Swal.fire({
            text: data.body.error,
            icon: "error",
            confirmButtonText: "Ok",
            showConfirmButton: true,
            customClass: {
              confirmButton: "d-block",
            },
          });
          this.pinCode = "";
        })
        .finally(() => {
          Overlay.hide();
        });
    },
  },
});
